import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=48e18c1a&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ViewForm.vue?vue&type=style&index=1&id=48e18c1a&prod&lang=scss&scoped=true"
import style2 from "./formstyles.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e18c1a",
  null
  
)

export default component.exports